import React, { useState } from 'react'
import { IProps } from './index'
import { SearchIcon } from '../SearchIcon'
import classnames from 'classnames'
import styles from './styles-legacy.scss'

import { Search as SearchDefault } from './component'
import { NewBrandingHoc } from '../../utils/NewBrandingHoc'

const SearchLegacy = ({ value, handleSearch }: IProps): React.ReactElement => {
  const [expanded, setExpanded] = useState(false)
  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) =>
    handleSearch(event.target.value)

  const toggleExpanded = () => setExpanded((expanded) => !expanded)

  return (
    <>
      <button
        className={classnames('search__opener', { 'search__opener--open': expanded })}
        onClick={toggleExpanded}
      >
        <SearchIcon />
      </button>
      <div
        className={classnames('search__field-input-wrap', {
          'search__field-input-wrap--open': expanded,
        })}
      >
        {!value && <SearchIcon />}
        <input
          className="search__field-input"
          type="search"
          value={value}
          onChange={handleInputChange}
          placeholder="Search"
        />
      </div>
      <style jsx>{styles}</style>
    </>
  )
}

export const Search = NewBrandingHoc(SearchLegacy, SearchDefault)
